import React from "react";
import { Link } from "react-router-dom";
import { Button, Flex, Tooltip } from "@fluentui/react-northstar";
import { ChevronDownIcon, CheckmarkCircleIcon } from "@fluentui/react-icons-northstar";
import ITask from "../interfaces/ITask";
import styles from "./taskItem.module.scss";
import { dueDateColor, parseDateToDateString } from "../common/dateOperations";
import { useApp } from "../contexts/appContext";

const colorByPriority = (code: number): string => {
    switch (code) {
        case 0: return "#2975b2";
        case 1: return "transparent";
        default: return "#da4f43";
    }
}

const iconByPriority = (code: number): JSX.Element => {
    switch (code) {
        case 0: return <ChevronDownIcon />;
        case 1: return <ChevronDownIcon rotate={270} />;
        default: return <ChevronDownIcon rotate={180} />;
    }
}

const titleByPriority = (code: number): string => {
    switch (code) {
        case 0: return "Nízká priorita"
        case 1: return "Normální priorita";
        default: return "Vysoká priorita";
    }
}

export interface ITaskItemProps extends ITask {
    showOwner: boolean;
    completeTask: (id: string, projectId?: string) => void;
};

const TaskItem: React.FunctionComponent<ITaskItemProps> = ({
    id, active, subject, priority, completedPercentage, dueDate, regarding, myRecord, completeTask, showOwner, owner
}) => {
    const { state: appState } = useApp();

    const completeTaskClicked = (e: any) => {
        e.preventDefault();
        if (id) {
            completeTask(id, regarding?.typeCode === "incident" ? regarding?.id : undefined);
        }
    };

    return (
        <Link to={`/task/detail/${id}`} className={styles.itemContainer}
            style={{ color: appState.color, background: `linear-gradient(90deg, #a6c3dc1e ${completedPercentage}%, transparent 0%)` }}>
            <Flex gap="gap.small" fill>
                <div style={{ backgroundColor: colorByPriority(priority) }}>&nbsp;</div>
                <div className={styles.icon}>
                    <Tooltip trigger={iconByPriority(priority)} content={titleByPriority(priority)} />
                </div>
                <Flex column>
                    <span className={styles.title}>{subject}</span>
                    <span className={styles.subTitle}>
                        {regarding?.id && <span>{regarding.typeName}: {regarding.title}</span>}
                    </span>
                    {showOwner && <span className={styles.subTitle}>Vlastník: {owner?.displayName}</span>}
                    {dueDate &&
                        <span className={styles.subTitle}>
                            Termín splnění: <span style={{ color: dueDateColor(dueDate) }}>{parseDateToDateString(dueDate)}</span>
                        </span>
                    }
                </Flex>
                {myRecord && active &&
                    <Flex.Item push>
                        <Flex gap="gap.medium" vAlign="center" className={styles.rightSide}>
                            <Tooltip content="Dokončit úkol" position-align="before-center" trigger={
                                <Button iconOnly text icon={<CheckmarkCircleIcon />} onClick={completeTaskClicked} />
                            } />
                        </Flex>
                    </Flex.Item>
                }
            </Flex>
        </Link>
    );
};

export default TaskItem;
